import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { Constants } from '../../shared/constants';
import {
    Box,
} from '@mui/material';
import { CustomIconButton } from '../../shared/utils/CustomIcon';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const EventCarousel = ({slides}) => {
    return (
        <Box sx={{ "& .swiper-pagination": { display: "none !important" } }}>
            <Swiper
                modules={[Pagination, Autoplay, EffectFade, Navigation]}
                effect="fade"
                spaceBetween={10}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop
                navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
                style={{
                    borderRadius: "40px",
                }}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <Box
                            sx={{
                                position: "relative",
                                height: { xs: "200px", sm: "260px", lg: "400px" },
                                backgroundImage: `url(https://stage.myskool.club/events/assets/admin/img/event-gallery/${slide})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                px: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderRadius: "40px",
                            }}>
                            <Box sx={{ display: 'flex', justifyContent: "space-between", width: "100%" }}>
                                <CustomIconButton className="custom-swiper-prev" icon={<ArrowBackIcon sx={{ color: "red.main", fontSize: "20px" }} />} bgcolor={"primary.main"} />
                                <CustomIconButton className="custom-swiper-next" icon={<ArrowForwardIcon sx={{ color: "red.main", fontSize: "20px" }} />} bgcolor={"primary.main"} />
                            </Box>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>

    )
}

export default EventCarousel